<template>
  <section class="why pb-5">
    <div class="container">
      <div class="d-flex justify-content-center flex-wrap logo-block mb-5">
        <img src="/images/bg-logo.png" class="logo-block__image" alt="Boiler Guide">
        <img src="/images/sg_logo.png" class="logo-block__image" alt="Solar Guide">
        <img src="/images/gm_logo.png" class="logo-block__image logo-block__image--wide" alt="Green Match">
        <img src="/images/hhq_logo.png" class="logo-block__image" alt="Household Quotes">
        <img src="/images/mi_logo.png" class="logo-block__image logo-block__image--widest" alt="Market Inspector">
      </div>
      <div class="text-center why-section-title pb-3 m-auto">
        <h2 class="m-auto pb-5 brand-color">
          Finding new customers, filling the diary and growing your business has never been easier.
        </h2>
      </div>
      <div class="row">
        <div class="col-sm-12 py-2 py-md-4 col-md-4">
          <div class="reason m-auto">
            <div class="reason-icon m-auto d-flex justify-content-center align-items-center rounded-circle">
              <font-awesome-icon :icon="['fas', 'user']" />
            </div>
            <div class="reason-title pt-2 pt-md-4 pt-lg-2 text-center">
              <h2 class="h3 font-weight-bold">
                Lead-Gen Experts
              </h2>
            </div>
            <div class="reason-intro text-center">
              <p>We’ve been providing top quality leads to our customers for more than 10 years.</p>
            </div>
          </div>
        </div>
        <div class="col-sm-12 py-2 py-md-4 col-md-4">
          <div class="reason m-auto">
            <div class="reason-icon m-auto d-flex justify-content-center align-items-center rounded-circle">
              <font-awesome-icon :icon="['fas', 'users']" />
            </div>
            <div class="reason-title pt-2 pt-md-4 pt-lg-2 text-center">
              <h2 class="h3 font-weight-bold">
                Consistent Volume
              </h2>
            </div>
            <div class="reason-intro text-center">
              <p>From 1 lead per week to 100s a day. <strong>You set the pace</strong>, we provide the customers.</p>
            </div>
          </div>
        </div>
        <div class="col-sm-12 py-2 py-md-4 col-md-4">
          <div class="reason m-auto">
            <div class="reason-icon m-auto d-flex justify-content-center align-items-center rounded-circle">
              <font-awesome-icon :icon="['fas', 'search']" />
            </div>
            <div class="reason-title pt-2 pt-md-4 pt-lg-2 text-center">
              <h2 class="h3 font-weight-bold">
                No Hidden Fees
              </h2>
            </div>
            <div class="reason-intro text-center">
              <p>
                Buy leads on a purely pay-as-you-go basis or take advantage of our flexible contracts. It’s up to you.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "RegisterSectionWhyUs",
};
</script>
<style scoped lang="scss">
.why {
  margin-top: 50px;

  .logo-block {
    &__image {
      max-width: 180px;
      margin: 5px 18px;
      &--wide {
        max-width: 260px;
      }
      &--widest {
        max-width: 300px;
      }

    }
  }

  &-section-title {
    max-width: 690px;
  }

  .reason-icon {
    background: $why-choose-icon-bg;
    font-size: 1.8rem;
    height: 60px;
    width: 60px;
    margin: 0 auto;

    &-title h3 {
      padding-top: 40px;
    }

    &-intro p {
      line-height: 1.4;

      strong {
        color: $theme-secondary-green-900;
      }
    }
  }
}
</style>
